import React, { useState,useEffect,useRef,useContext   } from "react";

import { Link,useParams,useNavigate  } from "react-router-dom";
import ReactGA from 'react-ga4';


import helpers from "../_helpers/helpersFunction";

import Lang from '../lang/translations';
import Context from '../context/context';
import helpersFunction from "../_helpers/helpersFunction";


export default function Testing_dumgum(props) {
    const [country, SetCountry] = useState(helpers.getCountry());
    const [categoria, setCategoria] = useState("icebreaker");

    const handleCategoriaChange = (event) => {
        setCategoria(event.target.value);
    };

    var trackerId = localStorage.getItem('trackerId');
    //popup states
console.log("Props testing_dumgum:", props);
            
    let params = useParams();

    const context = useContext(Context);
    
    var time = new Date();


        function hookToChatSubmit(prompt){


            context.Socket.emit('testing_dumgum', {'prompt' : prompt, categoria:categoria, 'trackerId': trackerId, 'angelId':props.attuale.id,"screenName":props.attuale.screenName,"servizio": window.location.hostname,"country":country,"time":time  });

        }

        return (<div style={{display: 'block', width: '100%',marginTop: '5px',textAlign:'center'}} >
            <label><b>TIPOLOGIA</b></label><br/>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_generico")
            }}>approccio_generico<br/><span>GENERIC</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_no_foto")
            }}>approccio_no_foto<br/><span>NO_PHOTO</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_vicino")
            }}>approccio_vicino<br/><span>NEARBY</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_angel_piu_vecchia")
            }}>approccio_angel_piu_vecchia<br/><span>MUCH_OLDER</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_angel_piu_giovane")
            }}>approccio_angel_piu_giovane<br/><span>MUCH_YOUNGER</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_visto_che_sei_online")
            }}>approccio_visto_che_sei_online<br/><span>USER_ONLINE</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_visto_che_sei_offline")
            }}>approccio_visto_che_sei_offline<br/><span>USER_OFFLINE</span></button>
            <button style={{padding: '5px', margin: '3px', border: 'none', background: '#ddd',fontSize: '10px'}} onClick={() => {
                hookToChatSubmit("approccio_appena_registrato")
            }}>approccio_appena_registrato<br/><span>JUST_JOINED</span></button><br/>
             <label><b>CATEGORIA</b></label><br/>
             {/*creo una radio button per selezionare se categoria icebreaker o approccio e lascio selezionata impostando uno stato*/
                               }
            <input type="radio" id="categoria_icebreaker" name="categoria" value="icebreaker" checked={categoria === "icebreaker"} onChange={handleCategoriaChange} />
            <label htmlFor="categoria_icebreaker">Icebreaker</label><br />
            <input type="radio" id="categoria_approccio" name="categoria" value="approccio" checked={categoria === "approccio"} onChange={handleCategoriaChange} />
            <label htmlFor="categoria_approccio">Revive</label><br />

        </div>)

}